<template>
	<div class="roport content flex flex-align-start">
		<div class="flex-1 mr40 por">
			<div class="f16 fwb">高阶报告填写基本信息：</div>
			<el-form :model="form" :rules="rules" ref="form" label-width="120px" class="mt20">
				<div class="flex-text">
					<el-form-item class="flex-1" label="学生姓名" prop="name">
						<el-input :maxlength="100" v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="学生性别" prop="sex">
						<el-select v-model="form.sex" placeholder="学生性别">
						    <el-option label="男" value="男"></el-option>
						    <el-option label="女" value="女"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1" label="出生年月" prop="birth">
						<el-date-picker v-model="form.birth" type="month" :default-value="defaultDate" value-format="yyyy年MM月" format="yyyy年MM月" placeholder="选择日期"></el-date-picker>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="目前户籍地" prop="area">
						<el-cascader v-model="form.area" :options="areaData" @change="area = getSelectedLabels($event)"></el-cascader>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1" label="高考成绩" prop="examResults">
						<el-input :maxlength="100" v-model="form.examResults"></el-input>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="高考数学成绩" prop="maths">
						<el-input :maxlength="100" v-model="form.maths"></el-input>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1" label="就读院校" prop="school">
						<!-- <el-input :maxlength="100" placeholder="请准确填写学校全称" v-model="form.school"></el-input> -->
						<el-select class="" v-model="form.school" filterable remote placeholder="就读院校" :loading="isLoading" :remote-method="remoteSchoolMethod">
						    <el-option v-for="(item,index) in schools" :key="index" :label="item" :value="item"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="当前年级" prop="grade">
						<el-select v-model="form.grade" placeholder="当前年级">
						    <el-option :label="item" :value="item" v-for="(item,index) in grade" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1 long" label="就读院校所属省份" prop="schoolProvince">
						<el-cascader v-model="form.schoolProvince" :options="provinceData" @change="schoolProvince = getSelectedLabels($event)"></el-cascader>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="生源地省份" prop="originProvince">
						<el-cascader v-model="form.originProvince" :options="provinceData" @change="originProvince = getSelectedLabels($event)"></el-cascader>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1" label="学历层次" prop="qualifications">
						<el-select v-model="form.qualifications" placeholder="学历层次" @change="form.major = '',majors = []">
						    <el-option :label="item.text" :value="item.text" v-for="(item,index) in qualifications" :key="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="专业" prop="major">
						<el-select class="" v-model="form.major" filterable remote :placeholder="!form.qualifications?'请先选择学历层次':''" :disabled="!form.qualifications" :loading="isLoading" :remote-method="remoteMethod">
						    <el-option v-for="(item,index) in majors" :key="index" :label="item" :value="item"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1" label="是否学生干部" prop="cadre">
						<el-select v-model="form.cadre" placeholder="是否学生干部" @change="form.cadrePositions = ($event == '否' ? '无' : '')">
						    <el-option label="是" value="是"></el-option>
							<el-option label="否" value="否"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="学生干部职务" prop="cadrePositions">
						<el-input :maxlength="100" :disabled="form.cadre == '否'" v-model="form.cadrePositions"></el-input>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1" label="参军入伍经历" prop="military">
						<el-select v-model="form.military" placeholder="参军入伍经历" @change="form.militaryOld = ($event == '有' ? '' : '无')">
							<el-option label="有" value="有"></el-option>
							<el-option label="无" value="无"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="参军时长" prop="militaryOld">
						<el-select v-model="form.militaryOld" placeholder="参军时长" :disabled="form.military == '无'">
						   <el-option label="无" value="无" :disabled="form.military == '有'"></el-option>
						   <el-option label="2年" value="2年"></el-option>
						   <el-option label="5年及以上" value="5年及以上"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1" label="政治面貌" prop="political">
						<el-select v-model="form.political" placeholder="政治面貌">
						    <el-option :label="item" :value="item" v-for="(item,index) in political" :key="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="flex-1 ml10" label="英语等级" prop="english">
						<el-select v-model="form.english" placeholder="英语等级">
						    <el-option :label="item" :value="item" v-for="(item,index) in english" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1 long" label="最高学历期间主要荣誉" prop="honor">
						<el-select v-model="form.honor" placeholder="同时具备多项的，选其中一项即可">
						    <el-option :label="item" :value="item=== '以上均无' ? '无' : item" v-for="(item,index) in honors" :key="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="flex-1 long ml10" label="通过或取得的其他资格" prop="otherHonor">
						<el-select v-model="form.otherHonor" placeholder="同时具备多项的，选其中一项即可">
						    <el-option :label="item" :value="item=== '以上均无' ? '无' : item" v-for="(item,index) in otherHonor" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="flex-text mt25">
					<el-form-item class="flex-1 long" label="岗位示例省份" prop="workProvince">
						<el-select v-model="form.workProvince">
						    <el-option :label="item" :value="item" v-for="(item,index) in workProvince" :key="index"></el-option>
						</el-select>
					</el-form-item>
					<div class="flex-1 ml10"></div>
				</div>
				<div class="mt25">
					<el-button class="" style="margin-left: 120px;" type="primary" @click="submitForm('form')" :disabled="disabled">生成报告</el-button>
				</div>
			</el-form>
			
			<!-- loading 弹窗 -->
			<transition name="el-fade-in-linear">
				<div v-show="visible" class="pob pob-cover flex-text" style="background-color: rgba(255,255,255,.6);z-index: 99;backdrop-filter: brightness(100%) saturate(100%) blur(2px);">
					<!-- 生成中 -->
					<div class="flex-text flex-v" v-if="state == 'INIT'">
						<div class="round" style="padding: 1px;border: 1px solid #00a1ff;">
							<div class="por round" style="width: 356px;background-color: rgba(0,161,255,.1);height: 16px;">
								<div class="pob round" style="height: 16px;background: linear-gradient(to right, #64c1f7, #00a1ff);left: 0;top: 0;" :style="{ width: progress + '%' }"></div>
							</div>
						</div>
						<div class="mt10 flex-text">
							<img class="block18 loadingGif" src="@/static/loading.png" alt="" />
							<div class="ml10 f16 fwb">{{ loadingText[Math.floor(progress / (100 / loadingText.length))] || loadingText[loadingText.length - 1] }}</div>
						</div>
					</div>
					
					<!-- 成功 -->
					<div class="flex-text flex-v" v-if="state == 'FINISH'">
						<i class="el-icon-success color-theme" style="font-size: 100px;"></i>
						<div class="mt10 f16 fwb">恭喜！报告生成成功</div>
						<div class="color-content mt10 f13">可在“我的-我的订单”中查看/下载报告</div>
						<div class="mt30 flex-text">
							<el-button type="primary" round plain @click="visible = false,$refs.form.resetFields()">我知道了</el-button>
							<el-button class="ml20" type="primary" round @click="$router.push('my-order?activeIndex=1')">查看报告</el-button>
						</div>
					</div>
					
					<!-- 失败 -->
					<div class="flex-text flex-v" v-if="state == 'ERROR'">
						<i class="el-icon-error" style="font-size: 100px;color: #F56C6C;"></i>
						<div class="mt10 f16 fwb">抱歉！报告生成失败</div>
						<div class="color-content mt10 f13">可点击下方按钮，重新提交生成报告</div>
						<div class="mt30 flex-text">
							<el-button type="primary" round plain @click="visible = false">我知道了</el-button>
						</div>
					</div>
				</div>
			</transition>
		</div>
		
		<!-- 宣传图 -->
		<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
			<el-carousel-item v-for="(item,index) in swiper" :key="index">
				<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
import { provinceAndCityData, regionData } from 'element-china-area-data'
export default {
	name: 'Report',
	data(){
		return{
			reportId: null,  // 生成的报告id
			disabled: false,  // 生成报告按钮
			timer: null,
			
			form: {
				name: '',  // 姓名
				sex: '',  // 性别
				birth: '',  // 出生年月
				area: [],  // 目前户籍地
				examResults: '',  // 高考成绩
				maths: '',  // 高考数学成绩
				school: '',  // 就读院校
				grade: '',  // 当前年级
				schoolProvince: [],  // 就读院校所属省份
				originProvince: [],  // 生源地省份
				qualifications: '',  // 学历层次
				major: '',  // 专业
				cadre: '',  // 是否学生干部
				cadrePositions: '',  // 学生干部职务
				military: '',  // 参军入伍经历
				militaryOld: '',  // 参军时长
				political: '',  // 政治面貌
				english: '',  // 英语等级
				honor: '',  // 最高学历期间主要荣誉
				otherHonor: '',  // 通过或取得的其他资格
				workProvince: ''  // 岗位示例省份
			},
			
			visible: false,  // 是否显示弹窗
			state: '',  // 报告生成状态  INIT：生成中  FINISH：成功  ERROR：失败
			duration: 0,  // 需要显示的动画时长
			loadingText: [],
			animationId: null,
			startTime: null,
			progress: 0,
			
			areaData: regionData,
			area: [],  // 选择的户籍地，格式：['河北省', '石家庄市', '长安区']
			schoolProvince: [],  // 选择的就读院校省份，格式：['河北省']
			originProvince: [],  // 选择的生源地省份，格式：['河北省']
			grade: ['大一', '大二', '大三', '大四', '研一', '研二', '研三', '已毕业'],
			qualifications: [
				{ text: '专科', type: 'ZYML_ZK' },
				{ text: '本科', type: 'ZYML_BK' },
				{ text: '硕士', type: 'ZYML_YJS' }
			],
			majors: [],
			schools: [],
			political: ['中共党员', '中共预备党员', '共青团员', '群众', '其他'],
			english: ['四级', '六级', '未通过四六级'],
			honors: ['校级优秀学生干部', '校级三好学生', '校级一等奖学金', '省级奖学金', '国家奖学金', '国家励志奖学金', '以上均无'],
			otherHonor: ['国家司法考试', '国家统一法律职业资格考试', '国家法律职业资格证书', '以上均无'],
			workProvince: [],
			
			rules: {
				name: [
					{ required: true, message: '请输入学生姓名', trigger: 'blur' },
				],
				sex: [
					{ required: true, message: '请选择学生性别', trigger: 'change' },
				],
				birth: [
					{ required: true, message: '请选择出生年月', trigger: 'blur' },
				],
				area: [
					{ type: 'array', required: true, message: '请选择目前户籍地', trigger: 'change' }
				],
				examResults: [
					{ required: true, message: '请输入高考成绩', trigger: 'blur' },
					{ pattern: /^\d+$/, message: '请输入数字值', trigger: 'blur' }
				],
				maths: [
					{ required: true, message: '请输入高考数学成绩', trigger: 'blur' },
					{ pattern: /^\d+$/, message: '请输入数字值', trigger: 'blur' }
				],
				school: [
					{ required: true, message: '请输入就读院校', trigger: 'blur' }
				],
				grade: [
					{ required: true, message: '请输入当前年级', trigger: 'change' }
				],
				schoolProvince: [
					{ type: 'array', required: true, message: '请选择就读院校所属省份', trigger: 'change' }
				],
				originProvince: [
					{ type: 'array', required: true, message: '请选择生源地省份', trigger: 'change' }
				],
				qualifications: [
					{ required: true, message: '请选择学历层次', trigger: 'change' }
				],
				major: [
					{ required: true, message: '请选择专业', trigger: 'change' }
				],
				cadre: [
					{ required: true, message: '请选择是否学生干部', trigger: 'change' }
				],
				cadrePositions: [
					{ required: true, message: '请输入学生干部职务', trigger: 'blur' }
				],
				military: [
					{ required: true, message: '请选择参军入伍经历', trigger: 'change' }
				],
				militaryOld: [
					{ required: true, message: '请选择参军时长', trigger: 'change' }
				],
				political: [
					{ required: true, message: '请选择政治面貌', trigger: 'change' }
				],
				english: [
					{ required: true, message: '请选择英语等级', trigger: 'change' }
				],
				honor: [
					{ required: true, message: '请选择最高学历期间主要荣誉', trigger: 'change' }
				],
				otherHonor: [
					{ required: true, message: '请选择通过或取得的其他资格', trigger: 'change' }
				],
				workProvince: [
					{ required: true, message: '请选择岗位示例省份', trigger: 'change' }
				]
			}
		}
	},
	computed: {
		provinceData() {
			return provinceAndCityData.map(v => {
				return { label: v.label, value: v.value }
			})
		},
		defaultDate() {
			return new Date(new Date().getFullYear() - 22,0,1)
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		this.getData()
		
		this.getProvince()
	},
	beforeDestroy() {
	    cancelAnimationFrame(this.animationId);
	},
	methods: {
		async getData(){
			this.$http.get('/api/webs/report/getReportConfig', { isAuth: false })
			    .then(response => {
			        let res = response.data
					this.duration = res.loadingSec
					this.loadingText = res.configs
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		
		async getProvince(){
			this.$http.get('/api/webs/search/reportReportProvince')
			    .then(response => {
			        let res = response.data
					
					this.workProvince = res.list
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		
		async remoteMethod(query){
			if(!query) return this.majors = []
			this.isLoading = true
			let type = this.qualifications.find(v => v.text == this.form.qualifications).type
			
			this.$http.get('/api/webs/search/reportMajor', { isAuth: true, params: { type: type, majorNameLike: query } })
			    .then(response => {
			        let res = response.data
					
					this.isLoading = false
					
					this.majors = res.list.map(v => {
						return `${v.stuMajor} / ${v.stuMajorGroup} / ${v.stuMajorTop}`
					})
			    })
			    .catch(error => {
			        console.error(error)
					this.isLoading = false
			    })
				
		},
		async remoteSchoolMethod(query){
			if(!query) return this.schools = []
			this.isLoading = true
			
			this.$http.get('/api/webs/search/report2Gxmd', { isAuth: true, params: { nameLike: query } })
			    .then(response => {
			        let res = response.data
					
					this.isLoading = false
					
					this.schools = res.list.map(v => {
						// return `${v.stuMajor} / ${v.stuMajorGroup} / ${v.stuMajorTop}`
						return v
					})
			    })
			    .catch(error => {
			        console.error(error)
					this.isLoading = false
			    })
				
		},
		submitForm(formName){
			if(!this.token) return EventBus.$emit('show-login', true)
			this.$refs[formName].validate((valid) => {
			    if (valid) {
					this.disabled = true
					
					let major = this.form.major.split(' / ')
					let params = {
						stuName: this.form.name,
						stuSex: this.form.sex,
						stuBirth: this.form.birth,
						stuProvince: this.area[0],
						stuCity: this.area[1],
						stuArea: this.area[2],
						stuScores: this.form.examResults,
						stuMathScores: this.form.maths,
						stuSchool: this.form.school,
						stuGrade: this.form.grade,
						stuSchoolProvince: this.schoolProvince[0],
						stuOriginProvince: this.originProvince[0],
						stuLevel: this.form.qualifications,
						stuMajor: major[0],
						stuMajorGroup: major[1],
						stuMajorTop: major[2],
						stuCadre: this.form.cadre,
						stuCadrePosition: this.form.cadrePositions,
						stuMilitary: this.form.military,
						stuMilitaryTime: this.form.militaryOld,
						stuPolitical: this.form.political,
						stuEnglishLevel: this.form.english,
						stuHonor: this.form.honor,
						stuCertificate: this.form.otherHonor,
						stuExpectProvince: this.form.workProvince
					}
					this.$http.post('/api/webs/report/buildReport', params)
						.then(response => {
				            let res = response.data
							this.reportId = res.reportId
							
							this.disabled = false
							this.visible = true
							this.state = 'INIT'
							
							// 进度条动画
							this.loadingGif()
							
							// this.state = 'FINISH'
							// this.state = 'ERROR'
							setTimeout(() => this.checkStatus(), this.duration * 1000)
						})
						.catch(error => {
				            console.error(error)
							this.disabled = false
						})
			    } else {
			        console.log('error submit!!');
					
			        return false;
			    }
			});
		},
		
		async checkStatus(){
			clearTimeout(this.timer)
			this.$http.get('/api/webs/report/getReportById', { params: { id: this.reportId } })
			    .then(response => {
			        let res = response.data
					this.state = res.state
					if(res.state == 'INIT') this.timer = setTimeout(() => this.checkStatus(), 1000)
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		
		loadingGif(){
			this.progress = 0;
			cancelAnimationFrame(this.animationId);
			      
			const duration = this.duration * 1000;  // 时长
			this.startTime = performance.now();
			      
			const animate = (currentTime) => {
				const elapsed = currentTime - this.startTime;
				const progress = Math.min(elapsed / duration, 1); // 0到1之间的进度
						
				this.progress = progress * 100; // 计算当前值
						
				if (progress < 1) {
					this.animationId = requestAnimationFrame(animate);
			    }
			};
			      
			this.animationId = requestAnimationFrame(animate);
		},
		
		// 根据value获取对应的label名称数组
		getSelectedLabels(value) {
		    if (!value || value.length === 0) return [];
		      
		    const labels = [];
		    let currentOptions = this.areaData;
		      
		    for (const val of value) {
				const found = currentOptions.find(item => item.value === val);
		        if (found) {
		            labels.push(found.label);
		            currentOptions = found.children || [];
		        } else {
		            break;
		        }
		    }
			
		    return labels;
		}
	}
}
</script>

<style>
.roport .el-input--suffix{
	width: 100% !important;
}
.roport .el-autocomplete{
	width: 100% !important;
}
.roport .el-cascader{
	width: 100% !important;
}
.roport .el-select{
	width: 100% !important;
}
.roport .el-textarea__inner{
	min-height: 70px !important;
}
.roport .loadingGif{
	animation: loading-rotate 1s linear infinite;
}
@keyframes loading-rotate {
	100%{
		transform: rotate(1turn);
	}
}

.roport .long .el-form-item__label{
	line-height: normal !important;
}
.roport .el-form-item__label{
	padding-left: 10px !important;
}
</style>